import { Box, Grid, TextField, FormControl, FormLabel, Switch, Typography } from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import ErrorSummary from 'components/common/ErrorSummary';

const EmployeeForm = ({ errors, input, handleInputChange, handleStatusChange, disabled = false }) => {
  return (
    <Box component="form" noValidate autoComplete="off" sx={{ my: 3 }}>
      <Box sx={{ mb: 2 }}>
        {errors && <ErrorSummary errors={errors} showEverything={false} mode="warning" />}
      </Box>
      <Grid container spacing={3}>
        <Grid
          size={{
            xs: 12,
            md: 3
          }}>
          <TextField
            fullWidth
            id="employeeName"
            name="name"
            label={intl.get('employeeForm.name')}
            placeholder={intl.get('employeeForm.placeholder.name')}
            value={input?.name || ''}
            onChange={handleInputChange}
            disabled={disabled}
            error={Boolean(errors?.name)}
            helperText={errors?.name || ' '}
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 3
          }}>
          <TextField
            fullWidth
            id="employeeLastName"
            name="lastName"
            label={intl.get('employeeForm.tradeName')}
            placeholder={intl.get('employeeForm.placeholder.tradeName')}
            value={input?.lastName || ''}
            onChange={handleInputChange}
            disabled={disabled}
            error={Boolean(errors?.lastName)}
            helperText={errors?.lastName || ' '}
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 3
          }}>
          <TextField
            fullWidth
            id="employeeEmail"
            name="emailAddress"
            label={intl.get('employeeForm.email')}
            placeholder={intl.get('employeeForm.placeholder.email')}
            value={input?.emailAddress || ''}
            onChange={handleInputChange}
            disabled={disabled}
            error={Boolean(errors?.emailAddress)}
            helperText={errors?.emailAddress || ' '}
            variant="outlined"
            size="small"
            type="email"
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 2
          }}
          sx={{ marginTop: -3 }}>
          <FormLabel sx={{ mb: 1 }}>{intl.get('statusSelect.label')}</FormLabel>
          <Box display="flex" alignItems="center" height={40}>
            <Switch
              checked={input?.isActive ?? true}
              onChange={handleStatusChange}
              disabled={disabled}
              size="small"
            />
            <Typography sx={{ ml: 1 }}>
              {input?.isActive !== false
                ? intl.get('roleRow.active')
                : intl.get('roleRow.inactive')}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmployeeForm;
